module.exports = __webpack_public_path__ + "static/media/linux.42ba6a43.svg";